// Compute the point along a controller's pointing laser at a given
// world-space distance from the controller. Used by gestures that want
// the drag to follow both controller translation AND aim direction —
// rotating the controller sweeps the endpoint around a virtual sphere
// at the captured grab distance, while moving the hand pushes it.
//
// Both move-selection and face-extrude key off this so they feel the
// same: press captures pick.distance as the grab distance, drag reads
// the endpoint each frame from the same helper. Both aim and arm
// translation map 1:1 — neither is amplified.

import * as THREE from "three";
import {
  controllerEffectiveWorldPos,
  controllers,
  laserLocalDir,
} from "../input/controllers";

const _ctrlPos = new THREE.Vector3();
const _ctrlDir = new THREE.Vector3();
const _endpointWorld = new THREE.Vector3();
const _matInv = new THREE.Matrix4();

// Endpoint in grid-local coords. Caller passes a pre-allocated `out`
// vector so we don't allocate on the per-frame path. Honors the
// squeeze-tilt so gestures driven through this helper (extrude, move)
// follow the same direction the user sees on the laser.
export function laserEndpointInGridLocal(
  controllerIndex: number,
  distance: number,
  gridGroup: THREE.Object3D,
  out: THREE.Vector3,
): void {
  const c = controllers[controllerIndex];
  controllerEffectiveWorldPos(controllerIndex, _ctrlPos);
  laserLocalDir(controllerIndex, _ctrlDir);
  _ctrlDir.transformDirection(c.matrixWorld).normalize();
  _endpointWorld.copy(_ctrlPos).addScaledVector(_ctrlDir, distance);
  _matInv.copy(gridGroup.matrixWorld).invert();
  out.copy(_endpointWorld).applyMatrix4(_matInv);
}
